import { Col, Container, Card, Button, Table, Spinner } from "react-bootstrap";
import Layout from "../../components/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import formatCurrency from "../../utils/currencyFormmter";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getOrdersToday } from "../../redux/slices/inventory.slice";
import InventoryConnectionButton from "../../components/InventoryConnector";
import Paginator from "../../components/table/Paginator";
import dateFormatter from "../../utils/dateFormatter";
import notification from "../../assets/audio/notification.wav"

const OrderHistory = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isLoaded = useRef(false)
    const audioRef = useRef(null)
    const currentOrderCountRef = useRef(0);

    const initialState = {
        loading: false,
        orders: [],
        order: {},
        payload: { page: 1 },
        paginationData: {},
    }

    const [state, setState] = useState(initialState)
    const [searchParams] = useSearchParams()

    const { invLogin } = useSelector((state) => state.inventory)
    const { user } = useSelector((state) => state.auth)
    const department = searchParams.get("department")

    useEffect(() => {
        getOrders()
        const intervalId = setInterval(getOrders, 10000);
        return () => clearInterval(intervalId);
    }, [invLogin, state.payload.page])

    const playNotificationSound = () => {
        audioRef?.current?.play()
    }

    const getOrders = () => {
        setState((prevState) => ({...prevState, loading: true}))
        dispatch(getOrdersToday({page: state.payload.page, department: department}))
        .then((response) => {
            if(response?.payload?.status === true) {
                const result = response.payload?.data?.data
                const pagination = {
                    next: response?.payload?.data?.data?.next_page_url,
                    prev: response?.payload?.data?.data?.prev_page_url,
                }
                const previousCount = currentOrderCountRef.current;
                const newCount = result.length;
            
                if (previousCount && newCount > previousCount) {
                  playNotificationSound();
                }
            
                currentOrderCountRef.current = newCount;
                setState((prevState) => ({...prevState, paginationData: pagination, orders: result}))
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }

    const handlePagination = (data) => {
        isLoaded.current = false
        setState((prevState) => ({...prevState, payload: {...prevState.payload,  page: data}}))
    }
    
    return (
        <Layout>
            <Container className="mt-4 px-4 mb-4">
                <InventoryConnectionButton />
                <Col md={12} className="row align-items-center justify-content-between flex-wrapd">
                    <div className="col-md-4">
                        <h3 className="m-0">Order Daily History</h3>
                        <p>
                            <small>Manage storefront order details</small>
                        </p>                        
                    </div>
                    <div className="col-md-8 text-right">
                        <Button 
                            type="button" 
                            className="border-0 mb-2 px-3 ms-2"
                            onClick={ () => navigate(user?.user_type === 'owner' ? '/inventory/storefront/orders' : '/members/inventory/storefront/orders')}
                        >
                            <FontAwesomeIcon icon={'receipt'}/>
                            <span className="ps-2">Orders</span>
                        </Button>
                        <Button 
                            type="button" 
                            className="border-0 mb-2 px-3 ms-2"
                            onClick={ () => navigate(user?.user_type === 'owner' ? '/inventory/storefront/products' : '/members/inventory/storefront/products')}
                        >
                            <FontAwesomeIcon icon={'box-open'}/>
                            <span className="ps-2">Products</span>
                        </Button>
                        <Button 
                            type="button" 
                            variant="primary" 
                            className="border-0 mb-2 ms-2"
                            onClick={ () => navigate( user?.user_type === 'owner' ? '/inventory/storefront' : '/members/inventory/storefront')}
                        >
                            <FontAwesomeIcon icon={'shop'} />
                            <span className="ps-2">Storefront</span>
                        </Button>
                        <Button 
                            type="button" 
                            variant="secondary" 
                            className="border-0 mb-2 ms-2 text-white"
                            onClick={ () => navigate(user?.user_type === 'owner' ? '/inventory/sell' : '/members/inventory/sell')}
                        >
                            <FontAwesomeIcon icon={'line-chart'} />
                            <span className="ps-2">Sell Product</span>
                        </Button>
                    </div>
                </Col>

                <div className="mt-4">
                    <Card className="border-0 shadow-sm rounded-14">
                        <Card.Body className="table-responsive-lg">
                            <audio ref={audioRef} src={notification} preload="auto" />
                            <Table size="sm" className="table-color table-striped">
                                    <thead>
                                        <tr>
                                            <th>Order Number</th>
                                            <th>Created By</th>
                                            <th>Item</th>
                                            <th>Price(₦)</th>
                                            <th>Quantity</th>
                                            <th>Amount(₦)</th>
                                            <th>Date</th>
                                            <th>Status</th>
                                            <th>Department</th>
                                        </tr>
                                    </thead>
                                    <tbody className="data-container">
                                        {
                                            state.loading ? (
                                                <tr className="in-page-loader">
                                                    <td colSpan={9}>
                                                        <Spinner size="sm" variant="primary"/>
                                                    </td>
                                                </tr>
                                            ) : null
                                        }
                                        {
                                            state.orders?.length ? (
                                                state.orders?.map((orderItem, index) => (
                                                    <tr key={orderItem.id}>
                                                        <td>
                                                            {index+1}.
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-plain text-primary font-bold p-0"
                                                                onClick={() => navigate(user?.user_type === 'owner' ? `/storefront/orders/${orderItem.order?.id}` : `/members/storefront/orders/${orderItem.order?.id}`)}
                                                            >
                                                                #{orderItem.order?.order_number}
                                                            </button> 
                                                        </td>
                                                        <td>
                                                            {orderItem.order?.user?.first_name+' '+orderItem.order?.user?.last_name}
                                                        </td>
                                                        <td>{orderItem.product_name}</td>
                                                        <td>{formatCurrency(orderItem.sales_price).formatted}</td>
                                                        <td>{formatCurrency(orderItem.quantity).formatted}</td>
                                                        <td>{formatCurrency(orderItem.quantity * orderItem.sales_price).formatted}</td>
                                                        <td>{dateFormatter(orderItem.order?.created_at)}</td>
                                                        <td className={orderItem.order?.order_status === 'cancelled' ? 'text-danger' : 'text-primary'}>{orderItem?.order?.order_status}</td>
                                                        <td className="font-bold">{orderItem?.department ?? '---'}</td>
                                                    </tr>
                                                ))
                                            )
                                            : 
                                            (
                                                <tr>
                                                    <td colSpan={9} className="text-center text-muted">No data found</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                    {
                        state.orders?.length ? (
                            <div className="table-responsive mt-2">
                                <Paginator
                                    next={state.paginationData.next}
                                    prev={state.paginationData.prev}
                                    setCurrentPage={ handlePagination }
                                />
                            </div>
                        ) : null
                    }
                </div>
            </Container>
        </Layout>
    );
}

export default OrderHistory;